import { makeAutoObservable } from "mobx";
import { PhoneNumber } from "../PhoneNumber";
/**
 * Contact details for voice ordering.
 * Only stores phone number from the caller - no name or email required.
 */
export class VoiceOrderContactDetails {
    constructor(params) {
        this.type = "VoiceOrder";
        this.contactDetailsLock = params.contactDetailsLock;
        this._phone = params.phone;
        makeAutoObservable(this);
    }
    static empty(validatePhoneService, contactDetailsLock) {
        return new VoiceOrderContactDetails({
            contactDetailsLock,
            phone: PhoneNumber.empty(validatePhoneService),
        });
    }
    static fromStorageData({ validatePhoneService, contactDetailsLock, storageData, }) {
        return new VoiceOrderContactDetails({
            contactDetailsLock,
            phone: new PhoneNumber({
                validatePhoneService,
                country: storageData.phoneCountry,
                value: storageData.phoneNumber,
            }),
        });
    }
    setData(data) {
        if (this.locked)
            return;
        if (data.phone !== undefined) {
            this.setPhone(data.phone.value, data.phone.country);
        }
    }
    get phone() {
        return this._phone;
    }
    setPhone(value, country) {
        if (this.locked) {
            throw new Error("Can't change phone number, ContactDetails locked");
        }
        this._phone.value = value;
        this._phone.country = country;
    }
    get email() {
        throw new Error("Can't access email at VoiceOrderContactDetails");
    }
    set email(_) {
        throw new Error("Can't set email at VoiceOrderContactDetails");
    }
    get fullName() {
        throw new Error("Can't access fullName at VoiceOrderContactDetails");
    }
    set fullName(_) {
        throw new Error("Can't set fullName at VoiceOrderContactDetails");
    }
    get locked() {
        return this.contactDetailsLock.locked;
    }
    unlock() {
        this.contactDetailsLock.unlock();
    }
    get availability() {
        return this._phone.availability;
    }
    get storageData() {
        return {
            type: "VoiceOrder",
            phoneNumber: this._phone.value,
            phoneCountry: this._phone.country,
        };
    }
}
